import { useEffect, useState } from "react";
import { UserCircleGear, ListChecks, PaperPlaneTilt } from "@phosphor-icons/react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { InitialsBadge } from "./InitialsBadge";
import { useAuth } from "../context/AuthContext";
import { InboxCompose } from "./InboxCompose";

export function TicketAssignCard({ t, isAdmin, onAssigned, onTaskSent }) {
  const [staff, setStaff] = useState([]);
  const [compose, setCompose] = useState(null);
  const { user } = useAuth();

  useEffect(() => { api.get("/inbox/staff").then((r) => setStaff(r.data)).catch(() => {}); }, []);

  const assign = async (user_id) => {
    try {
      const { data } = await api.patch(`/repair-tickets/${t.id}/assign`, { user_id: user_id || null });
      onAssigned(data);
      toast.success(user_id ? `Assigned to ${data.assigned_to_name}` : "Unassigned");
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="bg-white border border-[#E5E7EB] rounded-2xl shadow-[0_1px_3px_rgba(0,0,0,0.05)] p-5" data-testid="ticket-assign-card">
      <div className="mb-3 flex items-center gap-1.5 text-[10.5px] uppercase tracking-[0.18em] font-bold text-slate-500"><UserCircleGear size={14} weight="bold" />Assigned to</div>
      <div className="flex items-center gap-2.5">
        {t.assigned_to_name ? <InitialsBadge name={t.assigned_to_name} size={32} /> : <span className="w-8 h-8 rounded-full border border-dashed border-slate-300" />}
        <select value={t.assigned_to_id || ""} onChange={(e) => assign(e.target.value)} data-testid="ticket-assign-select"
          className="flex-1 min-w-0 h-10 px-3 rounded-xl border border-[#E5E7EB] bg-white text-[13px] font-semibold text-slate-800 focus:outline-none focus:border-[#1E5FEB]">
          <option value="">Not assigned</option>
          {user && <option value={user.id}>Me ({user.name})</option>}
          {Object.entries(staff.reduce((g, u) => { (g[u.store_name || "Other"] = g[u.store_name || "Other"] || []).push(u); return g; }, {}))
            .sort(([a], [b]) => a.localeCompare(b))
            .map(([store, people]) => (
              <optgroup key={store} label={store}>
                {people.map((u) => <option key={u.id} value={u.id}>{u.name}{u.role === "admin" ? " (admin)" : ""}</option>)}
              </optgroup>
            ))}
        </select>
      </div>

      {t.assigned_by && t.assigned_to_name && <div className="mt-1.5 pl-[42px] text-[11px] text-slate-400" data-testid="ticket-assigned-by">Assigned by {t.assigned_by}</div>}
      <div className="mt-4 flex gap-2">
        {isAdmin && <button onClick={() => setCompose("task")} data-testid="ticket-give-task-btn" className="flex-1 h-9 rounded-xl border border-[#BFDBFE] bg-[#EFF6FF] hover:bg-[#DBEAFE] text-[12.5px] font-semibold text-[#1E5FEB] inline-flex items-center justify-center gap-1.5 transition-colors"><ListChecks size={14} weight="bold" />Give task</button>}
        <button onClick={() => setCompose("message")} data-testid="ticket-message-staff-btn" className="flex-1 h-9 rounded-xl border border-[#E5E7EB] bg-white hover:border-[#BFDBFE] hover:text-[#1E5FEB] text-[12.5px] font-semibold text-slate-700 inline-flex items-center justify-center gap-1.5 transition-colors"><PaperPlaneTilt size={14} weight="bold" />Message</button>
      </div>
      <InboxCompose open={!!compose} onClose={() => setCompose(null)} onSent={onTaskSent} isAdmin={isAdmin}
        ticket={{ id: t.id, ticket_number: t.ticket_number }} defaultKind={compose || "message"} defaultTo={t.assigned_to_id || ""} />
    </div>
  );
}
